import { CollectDataStepType } from 'src/constants/collect-data/enums'
import type { PartnerDriverStep } from 'src/interfaces/partnerDriver'
import { formatDateOnly, parseIsoDate } from 'src/utils/grid'

const DETAILS_SEPARATOR = ' · '

const paymentMethodSummary = (step: PartnerDriverStep): string | null => {
  const details = step.metadata?.paymentMethodDetails

  if (!details) {
    return null
  }

  const parts = [
    details.paymentMethodType,
    details.accountType ?? details.cardType,
    details.nameOnAccount,
    details.last4 ? `•••• ${details.last4}` : undefined,
    details.expiryDate ? `exp ${details.expiryDate}` : undefined,
  ].filter((part): part is string => {
    return typeof part === 'string' && part.trim() !== ''
  })

  if (parts.length === 0) {
    return null
  }

  return parts.join(DETAILS_SEPARATOR)
}

/** The steps table's Details column — the extra info Retool showed for LMS and payment method. */
export const stepDetails = (step: PartnerDriverStep): string | null => {
  if (step.type === CollectDataStepType.LMSTraining) {
    const lmsEmail = (step.metadata?.partnerDriverLmsUserEmail ?? '').trim()

    if (lmsEmail !== '') {
      return `LMS email: ${lmsEmail}`
    }
  }

  if (step.type === CollectDataStepType.PaymentMethod) {
    const summary = paymentMethodSummary(step)

    if (summary) {
      return summary
    }
  }

  const expiresAt = parseIsoDate(step.partnerDriverCollectedData?.expiresAt)

  if (expiresAt) {
    return `Expires ${formatDateOnly(expiresAt)}`
  }

  return null
}
